/* eslint-disable no-unused-vars */

export enum TimeBucket {
  Monthly = "Monthly",
  Quarterly = "Quarterly",
  Yearly = "Yearly",
}

export enum CustomPeriod {
  PreviousPeriod = "pp",
  SamePeriodLastYear = "sppy",
}

export enum CustomBenchmark {
  PreviousPeriod = "Previous period",
  SamePeriodLastYear = "Same period last year",
}

// Type date filter
export enum DateFilterCategory {
  ROLLING = "ROLLING",
  FIXED = "FIXED"
}